<template>
    <div class="section-footer">
        <div class="section-footer__header">
            <div class="section-footer__header-top">
                <div class="section-footer__logo">
                    <img
                        @click="routerPush('/')"
                        src="@/assets/images/header/OMillionaire_logo_Final.svg"
                    />
                </div>
                <ul class="section-footer__list-menu">
                    <li
                        v-for="(item, index) in listMenu"
                        :key="index"
                        class="section-footer__item-menu"
                    >
                        <a :href="item.href" class="t-transform-cap">{{
                            getTranslatedText(item.title)
                        }}</a>
                    </li>
                </ul>
                <div class="section-footer__contact">
                    <h6 class="section-footer__contact-title">
                        {{ getTranslatedText("connect with us on") }}
                        <a
                            class="section-footer__contact-title__email"
                            href="mailto:support@omillionaire.com"
                        >
                            <b>support@omillionaire.com</b>
                        </a>
                    </h6>
                    <ul class="section-footer__list-contact">
                        <li
                            v-for="(item, index) in listContact"
                            :key="index"
                            class="section-footer__item-contact"
                        >
                            <a :href="item.href" target="_blank">
                                <img
                                    class="section-footer__item-contact__icon"
                                    :class="[`section-footer__item-contact__${item.class}`]"
                                    :src="
                                        require(`@/assets/images/footer/${item.icon}`)
                                    "
                                    :alt="item.icon"
                                />
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="section-footer__header-bottom">
                <p class="section-footer__header-bottom__address">
                    {{
                        getTranslatedText(`45 Bausher, Ghala Ind, Way No 319 Building 110, FLoor 3
                    Muscat, Oman`)
                    }}
                </p>
            </div>
        </div>

        <div class="section-footer__footer">
            <ul class="section-footer__footer-list-copy">
                <li
                    v-for="(item, index) in listMenuCopyRight"
                    :key="index"
                    class="section-footer__footer-item-copy t-transform-cap"
                >
                    <template v-if="item.href">
                        <a :href="item.href" class="t-transform-cap">{{
                            getTranslatedText(item.title)
                        }}</a>
                    </template>
                    <template v-else>
                        {{ getTranslatedText(item.title) }}
                    </template>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import languageMixin from "@/mixins/language/language-mixin";
import RouterMixin from "@/mixins/router/router-mixin"

export default {
    mixins: [languageMixin, RouterMixin],
    data() {
        return {
            listMenu: [
                {
                    title: "About us",
                    href: "/about-us",
                },
                // {
                //     title: "Green Initiative",
                //     href: "/green",
                // },
                // {
                //     title: "How to play",
                //     href: "/how-to",
                // },
                // {
                //     title: "Draws",
                //     href: "/draws",
                // },
                {
                    title: "t&cs",
                    href: "/term-conditions",
                },
                {
                    title: "News",
                    href: "/news",
                },
            ],
            listContact: [
                {
                    icon: "Icon_Youtube.svg",
                    class: "icon-youtube",
                    href: "https://www.youtube.com/channel/UCCZxGo-Fgh-Vd47jxUBjnww/featured",
                },
                {
                    icon: "Icon_Facebook.svg",
                    href: "https://www.facebook.com/OMillionaireom-110101778237267/",
                },
                {
                    icon: "Icon_Twitter.svg",
                    href: "https://twitter.com/Omillionaire_me?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor",
                },
                {
                    icon: "Icon_Instagram.svg",
                    href: "https://instagram.com/omillionaire.om?igshid=YmMyMTA2M2Y=",
                },
                // {
                //     icon: "snapchat.png",
                //     href: "https://www.snapchat.com/omillionaire_om/",
                // },
                {
                    icon: "Icon_Tiktok.svg",
                    href: "https://www.tiktok.com/@omillionaire_me",
                },
            ],
            listMenuCopyRight: [
                {
                    title: "© O!Millionaire 2022",
                },
                // {
                //     href: "/term-conditions",
                //     title: "t&cs",
                // },
                {
                    title: "All Rights Reserved 2022",
                },
            ],
        };
    },
    methods: {},
};
</script>
<style scoped lang="scss" src="@/assets/scss/mobile/_footer.scss" />
